export const convertBase64Image = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject('No file provided');
        return;
      }
      
      const reader = new FileReader();
      
      // Read the file as a data URL (Base64)
      reader.readAsDataURL(file);
  
      // On successful read, resolve with the result (base64 string)
      reader.onload = () => {
        resolve(reader.result);
      };
  
      // On error, reject the promise with the error
      reader.onerror = (error) => {
        reject(error);
      };
    });
  };
  